import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Button, Container } from '@chakra-ui/react';
import MediaBackground from '@rsc/ui-components/dept/molecules/MediaBackground';
import { generateSectionId } from '@rsc/ui-components/dept/utils/generateSectionId';
import Link from '@rsc/ui-components/tailwind/Link';

function Hero({ block }) {
  const { title, description, background, alignment, cta } = block;

  const handleAlignment = (leftValue, centerValue, rightValue) => {
    const values = {
      left: leftValue,
      center: centerValue,
      right: rightValue,
    };

    return values[alignment];
  };

  return (
    <Container {...generateSectionId(block)}>
      <MediaBackground
        display="flex"
        justifyContent={handleAlignment('flex-start', 'center', 'flex-end')}
        background={background}
        mb={{ base: '3rem', lg: '5rem' }}
      >
        <Flex
          alignItems={handleAlignment('flex-start', 'center', 'flex-end')}
          textAlign={handleAlignment('left', 'center', 'right')}
          direction="column"
          alignSelf="end"
          zIndex={1}
          m={{ base: 6, lg: 16 }}
          maxW={{ base: 'full', lg: handleAlignment('38rem', '70%', '38rem') }}
        >
          {title && (
            <Text
              as="h1"
              textStyle="h1"
              color="typography.lighter"
              mb={4}
              fontWeight="black"
            >
              {title}
            </Text>
          )}

          {description && (
            <Text color="typography.lighter" fontWeight="bold" mb={8}>
              {description}
            </Text>
          )}

          {cta?.text && (
            <Button as={Link} link={cta?.link}>
              {cta.text}
            </Button>
          )}
        </Flex>
      </MediaBackground>
    </Container>
  );
}

Hero.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    alt: PropTypes.string,
    image: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
}.isRequired;

export default Hero;
